import React, { useEffect } from "react";
import UploadData from "./UploadData";
import { OnboardingAxios, ProgramSetupAxios } from "../../../../API";
import DataTable from "../DataTable/DataTable";
import { Button, Modal } from "react-bootstrap";
import ExportExcel from "../Exports/ExportExcel";

const EligiblePool = (props) => {
    const [usersList, setUsersList] = React.useState([]);
    const [tableData, setTableData] = React.useState({});
    const [teams, setTeams] = React.useState([]);
    const [preferredMission, setPreferredMission] = React.useState([]);
    const roleLabels = { 3: 'Admin', 4: 'Learner', 5: 'Coach' };
    const [filters, setFilters] = React.useState({});
    const [filterData, setFilterData] = React.useState([]);

    useEffect(() => {
        getSAPUsers();
    }, [props.selectedOffering]);

    useEffect(() => {
        generateTableData();
    }, [usersList, teams, preferredMission]);

    const getSAPUsers = () => {
        ProgramSetupAxios.post("/EligiblePool/geteligibleuserbyoffering/" + props.selectedOffering)
            .then(function (response) {
                setUsersList(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

        ProgramSetupAxios.get("/OfferingMission/getmissionsbyoffering/" + props.selectedOffering)
            .then(function (response) {
                setPreferredMission(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

        getTeams();
    };

    const getTeams = () => {
        OnboardingAxios.get("/Team?includeConclaves=true&onlyConclaves=false")
            .then(function (response) {
                setTeams(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const generateTableData = () => {

        let roles = usersList.map((x) => {
            let label = roleLabels[x.role];
            return { value: x.role, label: label };
        });
        const ids = roles.map(o => o.value);
        roles = roles.filter(({ value }, index) => !ids.includes(value, index + 1));

        let columns = [
            {
                label: "Profile ?",
                field: 'userId',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    className: 'text-center',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    // get unique program names from offering list
                    { value: true, label: 'Yes' },
                    { value: false, label: 'No' },
                ]
            },
            {
                label: "Email",
                field: 'email',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Email',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Role",
                field: 'role',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Role',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    ...roles,
                ],

            },
            {
                label: "Preferred Mission",
                field: 'preferredMission',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'PreferredMission',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    ...preferredMission.map((x) => {
                        return { value: x.id, label: x.missionName };
                    }),
                    { value: 0, label: 'Blank' },
                ]

            },
            {
                label: "Team",
                field: 'teamId',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'TeamId',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    ...teams.filter(obj => obj.isConclave === false)
                        .map((x) => {
                            return { value: x.id, label: x.teamName };
                        }),
                    { value: 0, label: 'Blank' },
                ]
            },
            {
                label: "Conclave",
                field: 'conclaveId',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'NameConclaveId',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    ...teams.filter(obj => obj.isConclave === true)
                        .map((x) => {
                            return { value: x.id, label: x.teamName };
                        }),
                    { value: 0, label: 'Blank' },
                ]
            },
            {
                label: "Approved",
                field: 'isApproved',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Approved',
                    'className': 'text-center',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    { value: true, label: 'Yes' },
                    { value: false, label: 'No' },
                ]
            },
            {
                label: "Status",
                field: 'published',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Status',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    { value: true, label: 'Published' },
                    { value: false, label: 'Unpublished' },
                ]
            },

            {
                label: "Action",
                field: 'action',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                }
            },

        ];
        let rows = [];
        usersList.forEach((user) => {
            let row = {};
            let mission = preferredMission.find(x => x.id === user.preferredMission);
            let team = teams.find(x => x.id === user.teamId);
            let conclave = teams.find(x => x.id === user.conclaveId);

            row.id = { value: user.id, label: user.id, export: user.id };
            row.userId = { value: user.userId ? true : false, label: user.userId ? 'Yes' : 'No', export: user.userId ? 'Yes' : 'No' };
            row.email = { value: user.email, label: user.email, export: user.email };
            row.role = { value: user.role, label: roleLabels[user.role], export: roleLabels[user.role] };
            row.preferredMission = {
                value: user.preferredMission,
                label: mission
                    ? mission.missionName
                    : '-',
                export: mission && mission.missionName
            };
            row.teamId = {
                value: user.teamId,
                label: team
                    ? team.teamName
                    : '-',
                export: team && team.teamName
            };
            row.conclaveId = {
                value: user.conclaveId,
                label: conclave
                    ? conclave.teamName
                    : '-',
                export: conclave && conclave.teamName
            };
            row.isApproved = { value: user.isApproved, label: <ApprovedCheckBox user={user} />, export: user.isApproved ? 'Yes' : 'No' };
            row.published = { value: user.isOfferingUserCreated, label: user.isOfferingUserCreated ? "Published" : "Unpublished", export: user.isOfferingUserCreated ? "Published" : "Unpublished" };
            row.action = { value: "", label: <EditUserRow user={user} /> };
            rows.push(row);
        });

        setTableData({ columns, rows });
    };


    const EditUserRow = (props) => {
        const [show, setShow] = React.useState(false);
        const [localUser, setLocalUser] = React.useState(props.user);
        const [localTeams, setLocalTeams] = React.useState(teams);

        const updateUser = (e) => {
            e.preventDefault();
            ProgramSetupAxios.put(`/EligiblePool/updateeligibleusers`, [localUser])
                .then(() => {
                    getSAPUsers();
                    setShow(false);
                }).catch(err => {
                    console.log("updateUser: err", err);
                });
        };

        const AddTeam = (props) => {
            const [showAddTeam, setShowAddTeam] = React.useState(false);
            const [teamName, setTeamName] = React.useState('');
            const [missionName, setMissionName] = React.useState('');
            useEffect(() => {
                let mission = preferredMission.find(x => x.id === parseInt(localUser.preferredMission));
                if (mission) {
                    setMissionName(mission.missionName);
                }

            }, [localUser.preferredMission]);

            const createNewTeam = (e) => {
                e.preventDefault();
                let newTeam = {
                    offeringId: props.offeringId,
                    missionId: props.isConclave ? 0 : localUser.preferredMission,
                    teamName: teamName,
                    isConclave: props.isConclave || false,
                };

                setShowAddTeam(false);
                OnboardingAxios.post(`/Team/`, newTeam)
                    .then(res => {
                        OnboardingAxios.get("/Team?includeConclaves=true&onlyConclaves=false")
                            .then(function (response) {
                                setLocalTeams(response.data);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                        setShowAddTeam(false);
                    }).catch(err => {
                        console.log("createNewTeam: err", err);
                    }
                    );
            };

            return (<>

                <Button variant="outline-primary" className="btn-rounded btn-sm" onClick={() => setShowAddTeam(true)}>
                    <i className="fa fa-plus" />
                </Button>

                <Modal
                    show={showAddTeam}
                    onHide={() => setShowAddTeam(false)}
                    centered
                    animation={false}
                    className="admin-modal"
                    size="lg"
                >
                    <form onSubmit={createNewTeam}>
                        <Modal.Header >
                            <Modal.Title>Create {props.isConclave ? "Conclave" : 'Team'}</Modal.Title>
                            <div className="close" onClick={() => setShowAddTeam(false)}>
                                <span aria-hidden="true">&times;</span>
                            </div>
                        </Modal.Header>
                        <Modal.Body>

                            <div className="form-group ">
                                <label >Preferred Mission</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={missionName}
                                    readOnly
                                />

                            </div>

                            <div className="form-group">
                                <label >Team Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Team Name"
                                    value={teamName}
                                    onChange={(e) => setTeamName(e.target.value)} />
                            </div>
                            <div className="form-group checkbox-group">
                                <input
                                    type="checkbox"
                                    checked={props.isConclave}
                                    className="form-check-input pointer"
                                    disabled
                                />
                                <label> Conclave</label>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="link" className="btn-text" onClick={() => setShowAddTeam(false)}>
                                close
                            </Button>
                            <Button variant="primary" type="submit">Create team</Button>
                        </Modal.Footer>
                    </form>
                </Modal>
            </>);
        };

        return (
            <>
                <Button onClick={() => setShow(true)} variant="link" className="btn-text btn-sm" >
                    <i className="fa fa-pencil me-2" />
                    Edit
                </Button>
                <Modal
                    show={show}
                    centered
                    className="admin-modal"
                    size="lg"
                >
                    <form onSubmit={updateUser}>
                        <Modal.Header>
                            <Modal.Title>Edit User -<strong>{localUser.email} ({roleLabels[localUser.role]})</strong> </Modal.Title>
                            <div className="close" onClick={() => setShow(false)}>
                                <span aria-hidden="true">&times;</span>
                            </div>
                        </Modal.Header>
                        <Modal.Body className="admin-modal">
                            {/* {JSON.stringify(props.user)} */}
                            <div className="row">
                                <div className="form-group col-6">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" value={localUser.email} className="form-control" readOnly />
                                </div>
                                <div className="form-group col-6">
                                    <label htmlFor="role">Role</label>
                                    <select className="form-control" readOnly value={localUser.role}>
                                        {
                                            Object.keys(roleLabels).map((key, index) => {
                                                return <option key={index} value={key}>{roleLabels[key]}</option>;
                                            })
                                        }
                                    </select>
                                </div>
                            </div>

                            <div className="row">
                                <div className="form-group col-6">
                                    <label htmlFor="role">Preferred Mission</label>
                                    <select
                                        className="form-control"
                                        value={localUser.preferredMission}
                                        onChange={(e) => {
                                            setLocalUser({ ...localUser, preferredMission: e.target.value });
                                            // setLocalUser({ ...localUser, teamId: '' });
                                        }}>
                                        {
                                            preferredMission.map((mission, index) => {
                                                return <option key={index} value={mission.id}>{mission.missionName}</option>;
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="form-group col-6">
                                    <label htmlFor="role">Team</label>
                                    <div className="d-flex align-items-center gap-2">
                                        <select
                                            className="form-control"
                                            value={localUser.teamId}
                                            onChange={(e) => {
                                                setLocalUser({ ...localUser, teamId: e.target.value });
                                            }}
                                            required>
                                            <option value="">select team</option>
                                            {
                                                localTeams.filter(item => item.missionId == localUser.preferredMission).map((team, index) => {
                                                    if (!team.isConclave) {
                                                        return <option key={index} value={team.id} >{team.teamName}</option>;
                                                    }
                                                })
                                            }
                                        </select>
                                        <AddTeam offeringId={localUser.offeringId} />

                                    </div>
                                </div>
                                {localUser.role == 5 && <div className="form-group col-6">
                                    <label htmlFor="role">Conclave</label>
                                    <div className="d-flex align-items-center gap-2">
                                        <select
                                            className="form-control"
                                            value={localUser.conclaveId}
                                            onChange={(e) => {
                                                setLocalUser({ ...localUser, conclaveId: e.target.value });
                                            }}>
                                            {
                                                localTeams.filter(item => item.isConclave).map((team, index) => {
                                                    return <option key={index} value={team.id} >{team.teamName}</option>;

                                                })
                                            }
                                        </select>
                                        <AddTeam isConclave={true} offeringId={localUser.offeringId} />
                                    </div>
                                </div>}

                                <div className="form-group col-12 checkbox-group">
                                    <input
                                        id="approveCheckbox"
                                        type="checkbox"
                                        checked={localUser.isApproved}
                                        className="form-check-input pointer"
                                        onChange={(e) => { setLocalUser({ ...localUser, isApproved: e.target.checked }); }} />
                                    <label htmlFor="approveCheckbox"> Approve user.</label>
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <Button className="btn-text" variant="link" onClick={() => setShow(false)}>cancel</Button>
                            <Button variant="primary" type="submit" >Update</Button>
                        </Modal.Footer>
                    </form>
                </Modal>
            </>
        );
    };

    const ApprovedCheckBox = (props) => {
        const [user, setUser] = React.useState(props.user);
        const [isChecked, setIsChecked] = React.useState(false);

        useEffect(() => {
            setIsChecked(user.isApproved);
        }, [user]);

        const handleChange = (event) => {
            if (user.teamId <= 0 || user.preferredMission <= 0) {
                alert("Please select team and preferred mission.");
                return;
            }

            setIsChecked(event.target.checked);
            setUser({ ...user, isApproved: event.target.checked });
        };


        return (
            <input
                className="form-check-input pointer"
                type="checkbox"
                checked={isChecked}
                onChange={handleChange}
                disabled={user.isOfferingUserCreated && user.userId !== '0'}
            />
        );
    };


    const publishOffering = () => {
        ProgramSetupAxios.put(`/Offering/publishoffering/` + props.selectedOffering)
            .then(res => {
                console.log(res);
            })
            .catch(err => {
                console.log(err);
            });
    };

    return (
        <>
            <div className="page-header mb-4">
                <h1>Eligible Pool</h1>
                <div className="page-actions">
                    <Button variant="success" className="btn-sm" onClick={() => publishOffering()}><i className="fa fa-check-circle me-2" />Publish</Button>
                    <Button variant="secondary" className="btn-sm"><i className="fa fa-pencil-square-o me-2" /> Bulk action</Button>
                    <UploadData />
                    <ExportExcel jsonObject={filterData} />
                </div>
            </div>
            <div className="data-table">
                <DataTable {...tableData} setFilters={setFilters} filters={filters} setFilterData={setFilterData} />
            </div>
        </>
    );
};

export default EligiblePool;
